import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import "yet-another-react-lightbox/styles.css";
import Lightbox from "yet-another-react-lightbox";
import Loader from "../../../core/common/selfLoder";

interface AllGalleryImages {
  photo_id: number;
  photo_url: string;
  caption: string;
}
interface GalleryImagesResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: AllGalleryImages[];
}
const GalleryDetail = () => {
  const [openLightbox, setOpenLightbox] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const location = useLocation();

  const { data: galleryAllImags, loading: loading } =
    useApi<GalleryImagesResponse>(
      `/api/gallery-photos/${location.state.album_id}`,
      {
        method: "GET",
        autoCall: true,
      }
    );
  const handleImageClick = (index: number) => {
    setCurrentIndex(index);
    setOpenLightbox(true);
  };

  return (
    <>
      <Loader loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">All Moments Gallery</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/gallery">Gallery</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All Moments
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              {loading ? (
                <div className="text-center">Loading...</div>
              ) : galleryAllImags?.data?.length ? (
                <div className="row row-gap-4 justify-content-start">
                  {galleryAllImags.data.map((item, index) => (
                    <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
                      <div className="gallery-item cursor-pointer">
                        <img
                          src={
                            typeof item.photo_url === "string"
                              ? item.photo_url
                              : "/assets/img/placeholder.jpg"
                          }
                          alt="Gallery item"
                          className="img-fluid rounded w-100"
                          onClick={() => handleImageClick(index)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center text-muted py-4 fs-5">
                  <h3>No photos available in this album.</h3>
                </div>
              )}
            </div>
          </div>

          {/* Lightbox */}
          {galleryAllImags?.data?.length && (
            <Lightbox
              open={openLightbox}
              close={() => setOpenLightbox(false)}
              slides={galleryAllImags.data.map((img) => ({
                src: img.photo_url,
              }))}
              index={currentIndex}
            />
          )}

          <div className="text-center mt-3 mb-1">
            <Link to="/gallery" className="btn btn-primary">
              <i className="ti ti-arrow-left me-2"></i>Back to Gallery
            </Link>
          </div>
        </div>

        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default GalleryDetail;
